import { Box, Typography, Tooltip as Tp } from "@mui/material";
import { getTotalLogHours } from "api/services/organization";
import Loader from "components/Loader";
import useQueryParams from "hooks/useQueryParams";
import { useQuery } from "react-query";
import { ResType } from "types";
import { StyledTaskBox } from "../styles";
import DateRange from "../DateRange";
import { useState } from "react";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

function TaskStatusByClientNavigate() {
  const { queryParams } = useQueryParams();
  const [dates, setDates] = useState({ fromDate: null, toDate: null });

  const dashboardType = queryParams.type || "user";

//   const { data, isLoading }: ResType = useQuery(
//     ["total-loghours", { ...dates, dashboardType }],
//     getTotalLogHours
//   );

//   if (isLoading) return <Loader />;

  return (
    <Box>        <Typography variant="h6">Task Status by Client navigate</Typography>
</Box>

        
  );
}

export default TaskStatusByClientNavigate;
